import Menu from 'components/Menu'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NoContent from 'components/NoContent'
import { columnsDashboard } from 'data/columns'
import { withStyles } from '@material-ui/core'
import TableWrapper from 'components/Table'
import {
  getEventsItems,
  getEventsPagination,
  getFilterEvents,
  getIsLoadingEvents
} from 'redux/selectors/events'
import { getEvents, SET_EVENT_FILTER } from 'redux/modules/events/actions'
import Checkbox from 'components/Checkbox'

const Dashboard = ({ classes }) => {
  const dispatch = useDispatch()

  const events = useSelector(getEventsItems)
  const isEventsLoading = useSelector(getIsLoadingEvents)
  const eventsPagination = useSelector(getEventsPagination)
  const filterEvents = useSelector(getFilterEvents)

  const fetchEvents = (
    page = eventsPagination.page,
    newCount = eventsPagination.perPage,
    withoutLoading = false,
    filter = filterEvents
  ) => {
    if (newCount === 9999) newCount = eventsPagination.perPage

    dispatch(
      getEvents(
        {
          filter: filter
        },
        () => {},
        () => {},
        {
          page,
          count: newCount || eventsPagination.perPage
        },
        withoutLoading
      )
    )
  }

  useEffect(() => {
    fetchEvents(eventsPagination.page)
    let interval = setInterval(() => {
      fetchEvents(
        eventsPagination.page,
        eventsPagination.perPage,
        true,
        filterEvents
      )
    }, 30000)
    return () => clearInterval(interval)
  }, [eventsPagination.page, eventsPagination.perPage, filterEvents])

  useEffect(() => {
    document.title = 'Дашбоард'
  }, [])

  return (
    <div className={classes.wrapper}>
      <Menu />
      <div className={classes.table}>
        <Checkbox
          label="Важные"
          value={filterEvents}
          otherStyles={{ marginLeft: '2.5em' }}
          setValue={(value) =>
            dispatch({
              type: SET_EVENT_FILTER,
              payload: value ? 'urgent' : null
            })
          }
        />
        {events.length > 0 || isEventsLoading ? (
          <div className={classes.tableWrapper}>
            <TableWrapper
              page={eventsPagination.page}
              count={eventsPagination.perPage}
              amount={eventsPagination.amount - 1}
              items={events}
              onChangePage={fetchEvents}
              onChangePerPage={(newCount) => fetchEvents(1, newCount)}
              isLoading={isEventsLoading}
              columns={columnsDashboard}
              tableType={'events'}
            />
          </div>
        ) : (
          <NoContent text={'Нет эвентов'} />
        )}
      </div>
    </div>
  )
}

const styles = () => ({
  wrapper: {
    display: 'flex'
  },
  table: {
    width: '100%',
    padding: '1em 0'
  },
  tableWrapper: {
    padding: '0 2em'
  },
  search: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'baseline'
  },
  button: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  }
})

export default withStyles(styles)(Dashboard)
